import { render, staticRenderFns } from "./classEdit.vue?vue&type=template&id=8365017c&scoped=true&"
import script from "./classEdit.vue?vue&type=script&lang=js&"
export * from "./classEdit.vue?vue&type=script&lang=js&"
import style0 from "./classEdit.vue?vue&type=style&index=0&id=8365017c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8365017c",
  null
  
)

export default component.exports